import { render, staticRenderFns } from "./SpecialOsusume.vue?vue&type=template&id=909c1434&scoped=true&"
import script from "./SpecialOsusume.vue?vue&type=script&lang=ts&"
export * from "./SpecialOsusume.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialOsusume.vue?vue&type=style&index=0&id=909c1434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909c1434",
  null
  
)

component.options.__file = "SpecialOsusume.vue"
export default component.exports